module.exports = __webpack_public_path__ + "static/media/xiaolian.fecc076e.png";